<template>
  <div class="page">
    <div class="header-section">
      <div class="head-context">
        <div>
          <p class="weight">Bin Wang, PhD</p>
          <p>
            <span class="weight">Titile/Position:</span> Associate Professor/Researcher
          </p>
        </div>
        <div>
          <div class="weight">Affiliation:</div>
          <div>
            Institute of Reproductive and Child Health, School of Public
            Health,<br />
            Peking University, Beijing 100191, P.R. China
          </div>
        </div>
        <div>
          <span class="weight">Websiute: </span>
          <a href="https://irch.pku.edu.cn/jszy/binwang/faculty.htm" target="_blank" class="blue">https://irch.pku.edu.cn/jszy/binwang/faculty.htm  </a>
        </div>
        <div>
          <span class="weight">Main research directions:</span>
          <p>Environment Health, Exposome, Bioinformatics and Artificial intelligence</p>
        </div>
        <div>
          <span class="weight">Email: </span>
          <span class="blue">binwang@pku.edu.cn</span>
        </div>
      </div>
      <div class="img">
        <img class="head" :src="img" alt="" />
      </div>
    </div>
    <div class="section">
     <div class="weight">Brief introduction:</div>
      <div class="content">
        My main interest is to develop high-throughput methods for analyzing the human biological samples to reflect their environmental complex exposure characteristics. Our team aims to screen the reliable exposure biomarkers, as well as the health effect biomarkers, by adopting the multi-disciplinary research methods from environmental chemistry, epidemiology, bioinformatics, and clinical medicine, expecting to illustrate the associations between various environmental exposures and human health, mainly including reproductive toxicity and cardiovascular diseases. I have published a total of 60+  peer-reviewed SCI papers as the first or corresponding author (33 of JCR Q1), and 1 patent for invention, with more than 6500 citation times and H-index = 42 (Web of Science). The publication journals mainly include the areas of environmental science and reproductive health, prevention medicine, e.g. Environmental Health Perspectives, Environmental Science & Technology, Environmental Science & Technology Letters, Environmental International, The Innovation, China CDC Weekly, and Reproductive Toxicology.. I teach the graduate course of “Environmental Exposomics”, undergraduate courses of “Understanding the typical environmental pollution events”, and “Environment and Health” for Executive Master of Public Health in Global Health. I serve as the topic editor of Environmental Science & Technology in the area of machine learning and public health.
      </div>
    </div>
    <div class="section">
      <div class="weight">Representative papers:</div>
      <p>
        1. Zhang G, Lin W, Gao N, Lan C, Ren M, Yan L, Pan B, Xu J, Han B, Hu L, Chen Y, Wu Y, Zhuang L*, Qun Lu*, <b>Wang B</b>*, Fang M. Using Machine Learning to Construct the Blood−Follicle Distribution Models of Various Trace Elements and Explore the Transport-Related Pathways with Multiomics Data. Environmental Science & Technology. 2024, 58, 18, 7743–7757.
      </p>
      <p>
        2. Zhao F, Li L, Lin P, Chen Y, Xing S, Du H, Wang Z, Yang J, Huan T, Long C, Zhang L,<b>Wang B</b>*, Fang M*. HExpPredict: In Vivo Exposure Prediction of Human Blood Exposome using A Random Forest Model and Its Application in Chemical Risk Prioritization, Environ Health Perspect, 2023, 131:37009.
      </p>
      <p>
        3. <b>Wang B</b>, Pang Y, Li K, Jiang J, Zhu Y, Li Z, Pan B, Zhang L, Zhang Y, Ye R, Li Z*. First evidence on the adverse effect of maternal germanium exposure on fetal neural tube defects, Environ Sci Technol Lett. 2023, 10: 192–197.
      </p>
      <p>
        4. Feng Y, Su S, Lin W, Ren M, Gao N, Pan B, Zhang L, Jin L, Zhang Y, Li Z, Ye R, Ren A,<b>Wang B</b>*. Using Machine Learning to Expedite the Screening of Environmental Factors Associated with the Risk of Spontaneous Preterm Birth: From Exposure Mixtures to Key Molecular Events, Environ Sci Technol Lett, 2023, 10, 11, 1036–1044.
      </p>
      <p>
        5. Fang M., Hu L., Chen D., Guo Y, Liu J, Lan C, Gong J*, <span  class="weight">Wang B</span>*. Exposome in human health: Utopia or wonderland? The Innovation, 2021, 2: 100172.
      </p>
      <p>
        6. Liu X, Chen D*,<b>Wang B</b>*, Xu F, Pang Y, Zhang L, Zhang Y, Jin L, Li Z, Ren A. Does low maternal exposure to per- and polyfluoroalkyl substances elevate the risk of spontaneous preterm birth? A nested case-control study in China. Environ Sci Technol. 2020, 54: 8259-8268.
      </p>
      <p>
        7. Ren M#, Pei R#, Jiangtulu B#, Chen J#, Xue T, Shen S, Yuan X, Li K, Lan C, Chen Z, Chen X, Wang Y, Jia X, Li Z, Rashid A, Prapamontol T, Zhao X, Dong Z, Zhang Y, Zhang L, Ye R, Li Z, Guan W*,<b>Wang B</b>*. Contribution of temperature increase to restrain the transmission of COVID-19 in China. The Innovation, 2020, 2: 100071.
      </p>
      <p>
        8. Jia X#, Chen J#, Li L#, Na Jia*, Jiangtulu B, Xue T, Zhang L, Li Z, Ye R,<b>Wang B</b>*, Modeling the prevalence of asymptomatic COVID-19 infections in the Chinese Mainland. The Innovation, 2020, 1: 100026.
      </p>
      <p>
        9. <b>Wang B</b>#, Jin L#, Ren A*, Yuan Y, Liu J, Li Z, Zhang L, Yi D, Wang LL, Zhang Y, Wang X, Tao S, Finnell RH. Levels of polycyclic aromatic hydrocarbons in maternal serum and risk of neural tube defects in offspring. Environ Sci Technol, 2015, 49: 588-596.
      </p>
      <p>
        10. <b>Wang B</b>, Li K, Jin W, Lu Y, Zhang Y, Shen G, Wang R, Shen H, Li W, Huang Y, Zhang Y, Wang X, Li X, Liu W, Cao H, Tao S*. Properties and inflammatory effects of various size fractions of ambient particulate matter from Beijing on A549 and J774A.1 cells. Environ Sci Technol, 2013, 47: 10583-10590.
      </p>
      <div>Note：* Corresponding author, # Co-first author</div>
    </div>
  </div>
</template>
<script>
import img from '@/assets/people/head1.png';
export default {
  data() {
    return {
      img
    };
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.page {
  overflow: auto;
  padding: 20px 30px;
  text-align: left;
  font-size: $webpage-base-font-size;
}
.header-section {
  display: flex;
}
.head-context {
  display: flex;
  flex-direction: column;
  gap: 18px
}
.head {
  height: 200px;
  margin-left: 160px;
}
p {
  word-break: break-word;
  overflow: hidden;
  text-align: left;
  line-height: $line-height-x-large;
  margin-bottom: 0;
}
.content {
  word-break: break-word;
  overflow: hidden;
  text-align: left;
  line-height: $line-height-x-large;
}
.weight {
  font-weight: 600
}
.section {
  margin-top: 20px;
  padding-right: 25px;
}
.blue {
  color: $blue-light-1
}
.img {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 600px) {
  .header-section {
    display: flex;
    flex-direction: column;
  }
  .head {
    margin-left: 0;
    margin-top: 18px
  }
}
</style>
